// src/components/Footer.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { useBrand } from "../brand/BrandContext";

function Footer() {
  const brand = useBrand();
  const [email, setEmail] = useState("");
  const year = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    window.location.href = `mailto:${brand.mailto}?subject=Newsletter%20subscribe&body=${encodeURIComponent(
      `Please add me to the newsletter.\n\nEmail: ${email}`
    )}`;
  };

  return (
    <footer className="bw-footer-modern">
      <div className="bw-footer__container">
        
        {/* Top Section: Grid with Vertical Lines */}
        <div className="bw-footer__grid">
          
          {/* Column 1: Brand & Mission */}
          <div className="bw-footer__col bw-footer__col--brand">
            <div className="bw-footer__brand-wrap" onClick={scrollToTop}>
              <img src={brand.logoSrc} alt={`${brand.name} logo`} className="bw-footer__logo" />
              <span className="bw-footer__brandName">{brand.name}</span>
            </div>
            <p className="bw-footer__desc">
              {brand.tagline}
            </p>
          </div>

          {/* Column 2: Product Links */}
          <div className="bw-footer__col">
            <h5 className="bw-footer__heading">Product</h5>
            <nav className="bw-footer__nav">
              <Link to="/" onClick={scrollToTop}>Home</Link>
              <Link to="/about" onClick={scrollToTop}>About</Link>
              <Link to="/contactus" onClick={scrollToTop}>Contact Us</Link>
            </nav>
          </div>

          {/* Column 3: Legal Links */}
          <div className="bw-footer__col">
            <h5 className="bw-footer__heading">Legal</h5>
            <nav className="bw-footer__nav">
              <Link to="/privacypolicy" onClick={scrollToTop}>Privacy Policy</Link>
              <Link to="/terms" onClick={scrollToTop}>Terms of Service</Link>
              <Link to="/patents" onClick={scrollToTop}>Intellectual Property</Link>
              <a href={`mailto:${brand.mailto}`}>Report an Issue</a>
            </nav>
          </div>

          {/* Column 4: Newsletter */}
          <div className="bw-footer__col bw-footer__col--sub">
            <h5 className="bw-footer__heading">Stay Updated</h5>
            <p className="bw-footer__sub-text">
              Get the latest updates on new features.
            </p>
            <form className="bw-footer__form" onSubmit={handleSubscribe}>
              <div className="bw-input-wrap">
                <input
                  type="email"
                  className="bw-modern-input"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  aria-label="Email address"
                  required
                />
                <button type="submit" className="bw-modern-btn" aria-label="Subscribe">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Bottom Section: Copyright & Back to Top */}
        <div className="bw-footer__bottom">
          <p className="bw-copyright">© {year} {brand.name}. All rights reserved.</p>
          
          <button onClick={scrollToTop} className="bw-footer__top-btn">
            Back to top
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 15l-6-6-6 6"/>
            </svg>
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;